/** 已请求终止的超分提质任务 ID（列表页处理循环共用） */
const cancelledTaskIds = new Set();

export function isImageEnhanceTaskCancelled(taskId) {
  if (taskId == null) return false;
  return cancelledTaskIds.has(String(taskId));
}

/** 终止任务：标记取消，处理循环在每张图之间检测后退出 */
export function cancelImageEnhanceTask(taskId) {
  if (taskId == null) return;
  cancelledTaskIds.add(String(taskId));
}

export function clearImageEnhanceTaskCancelled(taskId) {
  if (taskId == null) return;
  cancelledTaskIds.delete(String(taskId));
}
